'use es6';

import { byName } from 'ContentUtils/constants/TemplateTypes';
/**
 * Template types that will have section delimiters in them.
 */

export const TEMPLATE_TYPES_WITHOUT_SECTION_DELIMITERS = new Set();
TEMPLATE_TYPES_WITHOUT_SECTION_DELIMITERS.add(byName.global_group.id);